module.exports = __webpack_public_path__ + "img/icone-excel.6929ed93.png";